import apiClient from "./apiClient";

export const getRiskRatingDefinitions = () => apiClient.get("/risk-rating-definitions");
export const updateRiskRatingDefinitions = (payload) => apiClient.put("/risk-rating-definitions", payload);

